import React, { useEffect, useState } from "react";
import TeacherPageContainer from "../../Container/TeacherPageContainer";
import JobListingFull from "../../../Components/JobListingFull/JobListingFull";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { API } from "../../../API";
import { notify } from "react-notify-toast";
import { applyToListing, addFavouriteListing, removeFavouriteListing } from "../../../redux/homePage/homePage.actions";

function JobListing(props) {
  const { job, inst, campus } = props;
  const [confirmedInterviewTime, setConfirmedInterviewTime] = useState(null)
  const [isLoaded, setIsLoaded] = useState(false)
  const [totalSearchable, setTotalSearchable] = useState(0)

  useEffect(() => {
    API.getInterviewJobList(props.user._id).then((res) => {
      const interview = res.data.listings?.find((int) => int._id === job._id)
      const interviewScheduleInfo = interview?.invited_interview?.find((int) => int.teacher_id === props.user._id)
        ?.interview_schedule_infos
      setConfirmedInterviewTime(interviewScheduleInfo?.find((schedule) => schedule.status === 'selected'))
      setIsLoaded(true)
    }).catch(err => {
      console.log(err.response)
    })

    API.getLogSearchableByUserId(props.user._id).then((result) => {
      if(result.data.data)
      setTotalSearchable(result.data.data)
    })
  }, [])
  // console.log(confirmedInterviewTime)

  const application = !!props.user.my_applications.find(
    (app) => app.listing_id === job._id
  );

  const interviewScheduleInfo = props.user.my_interviews.find(
    (int) => int.listing_id === job._id)?.interview_schedule_infos;

  // checks if the close_date has not been passed
  const hasClosedDatePassed = new Date(props.job.close_date) < Date.now();

  const tabs = [
    {
      text: "Search Jobs",
      pathname: "/JobBoard",
    },
    {
      text: "Saved Jobs",
      pathname: "/SavedJobs",
      disabled: true,
    },
    {
      text: "My Applications",
      pathname: "/MyApplications",
    },
    {
      text: "Job Listing",
      pathname: "/JobListing/" + job._id,
      active: true,
    },
  ];

  const sendApplication = () => {
    // todo: fill out application functionality
    const listing_id = props.job._id;
    const publisher_id = props.job.publisher_id;
    // const teacher_id = props.user._id;

    let missing_fields = []
    if (props.user) {
      if (props.user.img_url === '') {
        missing_fields.push('Profile Photo')
      }

      if (!props.user.first_name || !props.user.last_name || !props.user.contact_number ||
        !props.user.address_line1) {
        missing_fields.push('Personal Details')
      }

      if (!props.user.id_document_type || !props.user.identification_document_number || !props.user.issuing_place ||
        !props.user.id_document_expiry || !props.user.identification_filename) {
        missing_fields.push('Identification')
      }

      if (props.user.referees.length === 0) {
          missing_fields.push('Professional Referee')
      }

      if (props.user.is_elt === true) {
        if (props.user.qualifications && props.user.qualifications.length === 0) {
          missing_fields.push('ELT Qualifications')
        } else if (props.user.professional_experience.length === 0) {
          missing_fields.push('ELT Professional Experience')
        }
      }

      if (props.user.is_vet === true) {
        if ((props.user.vet_training_quals && props.user.vet_training_quals.length === 0)
          && (props.user.vet_industry_quals && props.user.vet_industry_quals.length === 0)) {
          missing_fields.push('VET Qualifications')
        } else if ((props.user.vet_training_exp && props.user.vet_training_exp.length === 0) &&
          (props.user.vet_industry_exp && props.user.vet_industry_exp.length === 0)) {
          missing_fields.push('VET Experience')
        }
      }

      let notification_text = 'Please complete the following items before applying for this role: '
        + missing_fields.join(', ')
      if (missing_fields.length > 0) {
        notify.show(notification_text);
        return false;
      }
    }

    const alreadyApplied = !!props.user.my_applications.find(app => app.listing_id === listing_id);
    if (alreadyApplied) {
      notify.show("You have already applied for this job listing.");
    }
    else {
      API.applyForListing(listing_id, props.user._id, inst.institution_name, publisher_id)
        .then((res) => {
          props.applyToListing(listing_id, inst, publisher_id)
          props.history.push("/ConfirmApplication", {
            job: job,
            inst: inst,
          })
        })
        .catch(err => {
          console.log(err.response);
          if (err.response.status === 401) {
            notify.show("Please log in to complete your application")
          }
          else {
            notify.show("Error applying to job listing")
          }
        });

    }
  }

  const favObj = props.user.my_favourites.find(fav => fav.listing_id === props.job._id)

  const toggleFavourite = () => {
    if (favObj) {
      props.removeFavouriteListing(props.job._id)
    }
    else {
      props.addFavouriteListing(props.job._id)
    }
  }

  return (
    <TeacherPageContainer user={props.user} header="Job Board" tabs={tabs}>
      {isLoaded ?
        <JobListingFull
          job={job}
          inst={inst}
          campus={campus}
          isViewAsTeacher
          isApplied={application}
          confirmedInterviewTime={confirmedInterviewTime}
          interviewScheduleInfo={interviewScheduleInfo}
          hasClosedDatePassed={hasClosedDatePassed}
          sendApplication={sendApplication}
          toggleFavouriteListing={toggleFavourite}
          isFaved={!!favObj}
          isSearchable={props.user.is_searchable || totalSearchable > 0}
          teacher={props.user}
        />
        :
        <div className='row d-flex justify-content-center'><div className="spinner spinner-5"/></div>
      }
    </TeacherPageContainer>
  );
}

function mapStateToProps(state) {
  return {
    user: state.user.user,
  };
}

const mapDispatchToProps = (dispatch) => ({
  applyToListing: (listing_id, inst, publisher_id) => dispatch(applyToListing(listing_id, inst, publisher_id)),
  addFavouriteListing: (listing_id) => dispatch(addFavouriteListing(listing_id)),
  removeFavouriteListing: (listing_id) => dispatch(removeFavouriteListing(listing_id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(JobListing));
